// import "./markup-menu";
import $ from 'jquery'
// import intlTelInput from 'intl-tel-input'
import sliders from './components/sliders'
import daterangepicker from 'daterangepicker'
import Select from './components/select'
global.$ = global.jQuery = $
require("./components/open-close");
require("@fancyapps/fancybox");
import 'social-likes-next';
document.addEventListener("DOMContentLoaded", () => {
  $(".question").click(function() {
    $(this).parents().toggleClass('active');
  });
  document.querySelectorAll('input[type="tel"]').forEach(function(input) {
      input.addEventListener("input", function () {
          this.value = this.value.replace(/[^0-9]/g, "");
      });
  });

  $(window).scroll(function() {
      if ($(this).scrollTop() > 0) {
          $('.header').addClass('fixed');
      } else {
          $('.header').removeClass('fixed');
      }
  });
  $(window).scroll(function() {
      if ($(this).scrollTop() > 400) {
          $('.arrow-up').fadeIn();
      } else {
          $('.arrow-up').fadeOut();
      }
  });
  $('.arrow-up').click(function() {
      $('html, body').animate({
          scrollTop : 0
      }, 800);
      return false;
  });
  $(".popup__close, .popup__overlay").click(function() {
    $(".popup").removeClass('show');
  });
  $(".mobile-opener").click(function() {
    $(this).toggleClass('active');
    $(".nav").toggleClass('show');
  });
  $(".about__video-overlay").click(function() {
    $(this).css('display', 'none');
  });
  $(".popup-opener").click(function() {
    $(".popup").addClass('show');
    $('.popup__title').text($(this).data('text'));
    $('.nav').removeClass('show');
    $('.mobile-opener').removeClass('active');
  });
  if ($(window).width() < 1250) {
    $(".header .get").appendTo(".nav");
    $(".menu-item-has-children > a").click(function() {
      $(this).siblings('ul').toggleClass('show');
    });
  }

  global.customSelect = new Select();
  sliders();

});



// WEBPACK FOOTER //
// app/scripts/index.js